module.exports = __webpack_public_path__ + "img/punchclock.06f81068.svg";